<!-- <form action="" [formGroup]="setup" ngxStripeCardGroup [elementsOptions]="elementsOptions" [stripe]="stripe">
    <div class="row">
        <div class="form-group mb-3">
            <input type="mail" class="form-control" name="" id="" aria-describedby="helpId"
                placeholder="Nombre completo" formControlName="name" i18n-placeholder>
        </div>
        <div class="form-group mb-3">
            <input type="mail" class="form-control" name="" id="" aria-describedby="helpId"
                placeholder="Correo electrónico:" formControlName="email" i18n-placeholder>
        </div>
    </div>
    <div class="row container_card ">
        <div class="col-12">
            <ngx-stripe-card-number [options]="cardOptions" containerClass="input-card mb-3 "></ngx-stripe-card-number>
        </div>
        <div class="col-6">
            <ngx-stripe-card-expiry [options]="cardOptions" containerClass="mb-3 input-card"></ngx-stripe-card-expiry>
        </div>
        <div class="col-6">
            <ngx-stripe-card-cvc [options]="cardOptions" containerClass="mb-3 input-card"></ngx-stripe-card-cvc>
        </div>
    </div>
    <button type="btn btn__default btn__block mt-3 mb-3" (click)="createToken()">
        Guardar
    </button>
</form> -->

<p>
  Your information is stored by
  <a href="https://stripe.com/" target="_blank">
    <fa-icon [icon]="iconStripe" size="2x" style="display: inline-block; vertical-align: middle"></fa-icon>
  </a>
</p>
@if (successLottery) {
  <div [formGroup]="setup" ngxStripeCardGroup [elementsOptions]="elementsOptions" [stripe]="stripe">
    <div class="row">
      <div class="form-group mb-3">
        <input type="mail" class="form-control" name="" id="" aria-describedby="helpId" placeholder="First Name" formControlName="first_name" i18n-placeholder />
        @if (setup.get("first_name")?.invalid && setup.get("first_name")?.touched) {
          <small>Is required.</small>
        }
      </div>
      <div class="form-group mb-3">
        <input type="mail" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Last Name" formControlName="last_name" i18n-placeholder />
        @if (setup.get("last_name")?.invalid && setup.get("last_name")?.touched) {
          <small>Is required.</small>
        }
      </div>
      <div class="form-group mb-3">
        <input type="mail" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Email:" formControlName="email" i18n-placeholder />
        @if (setup.get("email")?.invalid && setup.get("email")?.touched) {
          <small>Is required.</small>
        }
      </div>
      <div class="form-group mb-3">
        <input type="mail" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Instagram:" formControlName="ig" i18n-placeholder />
        @if (setup.get("ig")?.invalid && setup.get("ig")?.touched) {
          <small>Is required.</small>
        }
      </div>

      <!-- <div class="form-group mb-3">
      <select class="form-control" name="" id="" formControlName="country" i18n-placeholder>
        <option value="">Select Country:</option>
        @for (item of listCountries; track $index) {
        <option [value]="item.code">{{ item.name }}</option>
        }
      </select>
    </div> -->

      <div class="form-group container_card">
        <div class="row">
          <div class="col-12 mb-2">Card Information</div>
          <div class="col-12">
            <ngx-stripe-card-number [options]="cardOptions" containerClass="input-card mb-3 "></ngx-stripe-card-number>
          </div>
          <div class="col-6">
            <ngx-stripe-card-expiry [options]="cardOptions" containerClass="mb-3 input-card"></ngx-stripe-card-expiry>
          </div>
          <div class="col-6">
            <ngx-stripe-card-cvc [options]="cardOptions" containerClass="mb-3 input-card"></ngx-stripe-card-cvc>
          </div>
        </div>
      </div>
      <div class="form-check mt-3" [formGroup]="validateTerms">
        <label class="form-check-label">
          <input type="checkbox" class="form-check-input" formControlName="terms" />
          By accepting, you agree to our terms and conditions.
        </label>
        <br />
        @if (validateTerms.get("terms")?.value === false) {
          <small>*Is required.</small>
        }
      </div>
      @if (loading) {
        <div class="loadContainer p-5 text-center">
          <fa-icon [icon]="iconSpinner" size="4x" animation="spin" [style]="{ color: 'white' }"></fa-icon>
        </div>
      } @else {
        <button type="submit" (click)="createToken()" class="btn btn__default btn__block mt-3 mb-3">Aceptar</button>
      }

      <!-- <div class="text-center" [class.d-block]="loadingToken" [class.d-none]="!loadingToken">
       <fa-icon [icon]="iconSpinner" size="4x" animation="spin" [style]="{color:'white'}"></fa-icon>
    </div> -->
    </div>
  </div>
} @else {
  <div class="row">
    <div class="col-12 text-center">
      <p class="h4">¡Thank you for entering the raffle! <br />Your registration has been received</p>
      <p>We will contact you if you win.</p>
    </div>
  </div>
}
